import { QuestionsService } from './../../services/questionsService';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { Component, OnInit } from '@angular/core';
import { Question } from '../../models/question';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-add-question',
  templateUrl: './add-question.component.html',
  styleUrls: ['./add-question.component.css'],
})
export class AddQuestionComponent implements OnInit {
  question: Question;
  serviceId: number;
  isLoading: boolean = false;
  constructor(
    private diag: NbDialogRef<AddQuestionComponent>,
    private service: QuestionsService,
    private toast: NbToastrService,
    private route: Router
  ) {
    this.question = {} as Question;

    this.question.question = '';
    this.question.answer = '';
  }

  get isFormValid() {
    return this.question.question == '' ||
      this.question.answer == '' ||
      this.question.questionEN == '' ||
      this.question.answerEN == ''
      ? false
      : true;
  }

  ngOnInit(): void {
    this.route.events.subscribe(() => {
      this.diag.close('false');
    });
  }
  add() {
    this.isLoading = true;
    if (this.serviceId != null && this.serviceId !== 0) this.question.serviceId = this.serviceId;
    this.service.post(this.question).subscribe((res) => {
      this.isLoading = false;
      this.toast.show('تم إضافة السؤال بنجاح', '', { status: 'success', duration: 3000 });
      this.diag.close('true');
    });
  }

  closePopup() {
    this.diag.close('false');
  }
}
